import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { setGeneralFilters } from '@app/core/store/actions/filters.actions';
import { Store } from '@ngrx/store';
import { GeneralFilters } from '../models/general-models';
import { Observable, take, map } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const store = inject(Store<{ filters: GeneralFilters }>);

  const authService = inject(AuthService);
  const user = authService.userValue;

  // Seleccionar el estado de los filtros
  const generalFilters$: Observable<GeneralFilters> = store.select(state => state.filters);


  return generalFilters$.pipe(
    take(1),
    map((generalFilters: GeneralFilters) => {
      // Validar si los filtros no están definidos
      if (!generalFilters.startDate || !generalFilters.endDate) {
        const url = new URL(window.location.origin + state.url);
        const startday = url.searchParams.get('startday');
        const endday = url.searchParams.get('endday');
        const year = url.searchParams.get('year');

        const getLastDayOfMonth = (dateStr: string): string => {
          const date = new Date(dateStr);
          const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          return lastDay.toISOString().split('T')[0];
        };

        // Calcular los últimos 3 meses completos
        const getLastThreeCompleteMonths = (): { startDate: string; endDate: string; year: string } => {
          const now = new Date();
          
          // Obtener el último mes completo (mes anterior al actual)
          const lastCompleteMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
          
          // Calcular 3 meses atrás desde el último mes completo
          const threeMonthsAgo = new Date(lastCompleteMonth.getFullYear(), lastCompleteMonth.getMonth() - 2, 1);
          
          // Primer día del mes de inicio (3 meses atrás)
          const startDate = new Date(threeMonthsAgo.getFullYear(), threeMonthsAgo.getMonth(), 1);
          
          // Último día del último mes completo
          const endDate = new Date(lastCompleteMonth.getFullYear(), lastCompleteMonth.getMonth() + 1, 0);
          
          return {
            startDate: startDate.toISOString().split('T')[0],
            endDate: endDate.toISOString().split('T')[0],
            year: now.getFullYear().toString()
          };
        };

        const defaultDates = getLastThreeCompleteMonths();
        const endDate = endday ? getLastDayOfMonth(endday) : defaultDates.endDate;

        const newFilters: GeneralFilters = {
          startDate: startday ?? defaultDates.startDate,
          endDate: endDate,
          year: year ?? defaultDates.year,
        };


        // Despachar los nuevos filtros al store
        store.dispatch(setGeneralFilters({ generalFilters: newFilters }));
      }

      // Validar si el usuario está autenticado
      if (user) return true;

      router.navigate(['']);
      return false;
    })
  );
};
